import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource);

export default {
    requestRules: (context) => {
        Vue.http.get('https://eo9-backend.firebaseapp.com/api/pages/register').then(
            response => {
                    context.commit("setRules", response.data.rules);
            },
            error => {
                console.log(error);
            }
        )
    }
}